module.exports = __webpack_public_path__ + "static/img/leak_red.43d26ae.gif";


//////////////////
// WEBPACK FOOTER
// ./src/assets/imgs/icons/leak_red.gif
// module id = 717
// module chunks = 6